import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMultiSelectState } from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useServiceOrdersActionsList } from '../../../utils/actions/serviceOrders/list'
import MultiSelectMenu from '../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const { t } = useTranslation()
  const { selecteds } = useMultiSelectState()
  const menuOptions = useServiceOrdersActionsList(undefined, selecteds)

  return <MultiSelectMenu options={menuOptions} t={t} />
}

export default MultiRowsActions
